<template>
<el-form-item :label="$t('actions.project.settings.logoLabel')" class='logo-setting'>
  <order-logo-dialog ref='order-logo-dialog' />
  <el-radio-group theme='info' class='selector' v-model="type">
    <el-radio-button label='default'>{{$t('actions.project.settings.logo.default')}}</el-radio-button>
    <el-radio-button label='custom'>{{$t('actions.project.settings.logo.custom')}}</el-radio-button>
    <el-radio-button label='hide'>{{$t('actions.project.settings.logo.hide')}}</el-radio-button>
  </el-radio-group>

  <div class='logo-content'>
    <div class='default' v-if="type === 'default'">
      <p class='hint'>{{$t('hint.project.edit.logo.default')}}</p>
    </div>

    <div class='custom' v-if="type === 'custom'">
      <image-uploader tag='logo' v-model='logo' :title="$t('actions.project.settings.logo.cover')" class="logo-wrapper" v-if='editable' />
      <p class='hint' v-else>
        {{$t('actions.project.settings.logo.price')}}<a class='link' v-on:click="openOrder">{{$t('actions.project.settings.logo.priceBtn')}}</a>
      </p>
    </div>

    <div class='hide' v-if="type === 'hide'">
      <p class='hint' v-if='editable'>{{$t('hint.project.edit.logo.hide')}}</p>
      <p class='hint' v-else>
        {{$t('actions.project.settings.logo.price')}}<a class='link' v-on:click="openOrder">{{$t('actions.project.settings.logo.priceBtn')}}</a>
      </p>
    </div>
  </div>
</el-form-item>
</template>

<script>
import Vue from 'vue'
import OrderDialog from './logo/order.dialog'

Vue.component('order-logo-dialog', OrderDialog)

export default {
  data() {
    return {
      type: null,
      logo: null
    }
  },
  props: ['value', 'editable'],
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    }
  },
  watch: {
    value: function(newValue) {
      this.setData(newValue)
    }
  },
  methods: {
    setData(value) {
      let vm = this
      switch (value.type) {
        case 'default':
          vm.type = 'default'
          break
        case null:
        case 'hide':
          vm.type = 'hide'
          break
        default:
          vm.type = 'custom'
      }
      vm.logo = value.logo
    },
    save() {
      this.$emit('input', {
        type: this.type,
        logo: this.logo
      })
    },
    openOrder() {
      this.$refs['order-logo-dialog'].open({
        name: this.project.name,
        id: this.project.id
      })
    }
  }
}
</script>

<style lang='scss' scoped>
$logo-height: 120px;
.logo-setting {
    .logo-wrapper {
        margin-top: 15px;
        width: $logo-height;
        height: $logo-height;
    }

    .hint {
        line-height: 1;
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// logo.card.vue?051463fd